import React from 'react';

import JobListing from './JobListing';

export default function JobListings({ jobListings }) {
  return (
    <>
      {jobListings && (
        <div className="job-listings">
          {jobListings.map((listing, i) => (
            <JobListing key={`${listing.id}-${i}`} listing={listing} />
          ))}
        </div>
      )}
    </>
  );
}
